import * as React from 'react';
import _ from 'lodash';
import { Paper, makeStyles, Grid, Button } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { updateMultiplePax } from '../../store/departures'
import axios from "axios";

const useStyles = makeStyles((theme) => ({
  buttonMargin: {
    margin: theme.spacing(0),
  },
  closeButton: {
    margin: theme.spacing(0),
    minWidth: '2em',
    minHeight: '2em',
    maxHeight: '2em'
  }
}));

// NOTE // this component handles closeFlight and the noShow confirmation
export const NoShowModal = (props) => {
  const passengers = props.paxInfo && props.paxInfo.passengers ? props.paxInfo.passengers : []
  const row = props.row
  const classes = useStyles()
  const token = useSelector(state => state.auth.fredAccessToken)
  const dispatch = useDispatch()

  const handleCloseFlight = async (markNoShows) => {
    const authConfig = {'Authorization': `Bearer ${token}`}

    // TODO // need href, jkey, statusKey for closeFlight
    const statusResponse = await axios.get(row.statusHref, { headers:authConfig })
    const flightOutput = {
      flightLegStatus: {
        // NOTE // only one of these be true (active, cancelled, checkInClosed, closed, expired, locked)
        active: statusResponse.data.flightLegStatus.closed,
        closed: !statusResponse.data.flightLegStatus.closed
      },
      timestamp: statusResponse.data.timestamp
    }

    // depKey, pasKey, jKey
      let pasArray = []
      // NOTE // format the info for the url in the store
      for (let i = 0; i < passengers.length; i++) {
        const pax = passengers[i];
        // NOTE // only mark passengers not checked in as noShow
        if (pax.passengerJourneyDetail.travelStatus.notCheckedIn && markNoShows) {
          let paxOutput = {
            travelStatus: {
              // NOTE // only one property in travelStatus can be true
              noshow: true,
            },
            timestamp: pax.passengerJourneyDetail.timestamp
          }
          pasArray.push({ depKey: row.key, pasKey: pax.key, jKey: pax.passengerJourneyDetail.key, output: paxOutput })
        }
        // NOTE // mark checked in passengers as boarded
        else if (pax.passengerJourneyDetail.travelStatus.checkedIn) {
          let paxOutput = {
            travelStatus: {
              // NOTE // only one property in travelStatus can be true
              boarded: true,
            },
            timestamp: pax.passengerJourneyDetail.timestamp
          }
          pasArray.push({ depKey: row.key, pasKey: pax.key, jKey: pax.passengerJourneyDetail.key, output: paxOutput })
        }
      }

      // NOTE // format close flight information for the followup
      let cfInfo = {statusKey: row.statusKey, legKey: row.legKey, output: flightOutput}
      dispatch(updateMultiplePax(pasArray, cfInfo))
      // NOTE // marking noshow on a flight also marks return flights as noshow
      props.closeModal(false)
  };

  return (
    <Grid container justify="center" style={{marginTop: '25%'}}>
      <Grid container justify="center" item xs={12} lg={8}>
      <Paper style={{padding: '10px 10px 10px 10px',width: '50%'}}>
        <Grid container item xs={12}>
          <Grid container justify="center" item xs={11}>
            <h4>Mark passengers not checked in as no-shows?</h4>
          </Grid>
          <Grid container justify="flex-end" item xs={1}>
            <Button className={classes.closeButton} style={{backgroundColor: '#eb494e'}} onClick={() => {props.closeModal(false)}}>x</Button>
          </Grid>
        </Grid>
        <Grid container item xs={12}>
          <Grid container justify="center" item xs={3}></Grid>
          <Grid container justify="center" item xs={3}>
            <Button className={classes.buttonMargin} style={{backgroundColor: '#03fc66'}} onClick={() => {handleCloseFlight(true)}}>Yes</Button>
          </Grid>
          <Grid container justify="center" item xs={3}>
            <Button className={classes.buttonMargin} style={{backgroundColor: '#eb494e'}} onClick={() => {handleCloseFlight(false)}}>No</Button>
          </Grid>
        </Grid>
      </Paper>
      </Grid>
    </Grid>
  )
}